import { render } from "./Step1PatientInformation.vue?vue&type=template&id=2ab84f68"
import script from "./Step1PatientInformation.vue?vue&type=script&lang=js"
export * from "./Step1PatientInformation.vue?vue&type=script&lang=js"

import "./Step1PatientInformation.vue?vue&type=style&index=0&id=2ab84f68&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__